export default {
  button: {
    toMainPage: "Главная",
    login: "Войти",
    registration: "Регистрация",
    back: "Назад",
    rcGroupWiki: "RC Group Wiki",
  },
  title: "Авторизация",
  pageTab: {
    owner: "Владелец",
    manager: "Менеджер",
  },
  form: {
    country: "Страна",
    mail: "Почта",
    login: "Логин",
    password: "Пароль",
    repeatPass: "Повторите пароль",
    minInputSize: "Должен содержать не менее {size} символов",
  },
  noAccount: "Нет аккаунта?",
  forgotPassword: "Забыли пароль?",
  dontWorryAboutForgotPass:
    "Не переживайте, мы вышлем вам ссылку восстановления на почту",

  resetPass: {
    dontWorry: "Не переживайте, мы вышлем вам ссылку восстановления на почту",
    info: {
      title: "Информация для входа отправлена на вашу почту",
      sendedLink: "Мы отправили ссылку для изменения пароля на почту",
      checkSpam: "Если вы не получили письмо, проверьте папку «Спам»",
    },
    resendMail: "Отправить письмо повторно через 00:%{timer}",
    messageNotReceived: "Не пришло письмо?",
    title: "Смена пароля",
    enterNewPass:
      "Введите новый пароль, который будете использовать для входа в личный кабинет",
  },
  enterNewPassword: "Введите новый пароль",
  oldLink: "Ссылка устарела",
  failMailCheck: "Ошибка проверки email",
};
